module.exports = __webpack_public_path__ + "static/media/C7.88882ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C7.mp4
// module id = zvH8
// module chunks = 8